<template>
  <div class="change">
    <header>
      <div class="inner">
        <div class="mm_logo">
          <a href="/">
            <picture>
              <source :srcset="getImage('header/tategulogo_wh.png')" type="image/png" media="(min-width: 700px)">
              <img :src="getImage('header/tategulogo_wh.png')" type="image/png" alt="SKETCH ORDER">
            </picture>
          </a>
          <div class="powered">powered by Domans, inc.</div>
        </div>
        <div class="so_logo">
          <a href="/">
            <picture>
              <source :srcset="getImage('header/so_logo_header_w_kana.png')" type="image/png" media="(min-width: 700px)">
              <img :src="getImage('header/so_logo_header_w_kana.png')" type="image/png" alt="SKETCH ORDER">
            </picture>
          </a>
        </div>
        <nav>
          <ul>
            <li class="header_nav_item">
              <!-- <a>
                <picture>
                  <source :srcset="getImage('header/icon_mypage.png')" type="image/png" media="(min-width: 700px)">
                  <img :src="getImage('header/icon_mypage.png')" type="image/png" alt="マイページe">
                </picture>
              </a> -->
            </li>
            <li class="header_nav_item">
              <!-- <a @click="onCartButton">
                <picture>
                  <source :srcset="getImage('header/icon_cart.png')" type="image/png" media="(min-width: 700px)">
                  <img :src="getImage('header/icon_cart.png')" type="image/png" alt="カート">
                </picture>
              </a> -->
            </li>
          </ul>
        </nav>
        <div class="btn_menu">
          <!-- <a href="javascript:void(0);return false;">
            <picture>
              <source :srcset="getImage('header/btn_menu.png')" type="image/png" media="(min-width: 700px)">
              <img :src="getImage('header/btn_menu.png')" type="image/png" alt="menu">
            </picture>
          </a> -->
        </div>
      </div>
      <div class="shadow"></div>
    </header>
  </div>
</template>
<script>
import * as App from '../utils/App'

export default {
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getSketchResource(image)
    },
    onCartButton: function () {
      this.$router.push({
        name: 'Cart'
      })
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>
<style src="../css/header.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/main/js/components/Header.vue